import React from 'react'
import { getPerformanceRatingStyle, getRatingText } from '../utils/rating'

type RatingChipProps = { score: number | string }

const RatingChip: React.FC<RatingChipProps> = ({ score }) => {
  const ratingText = getRatingText(score)
  const ratingStyle = getPerformanceRatingStyle(ratingText)
  const baseTextClass = 'font-dm-sans text-[13px] leading-6 font-medium'

  return (
    <div
      className={`flex items-center gap-2 px-2 py-0.5 rounded-[5px] w-fit ${ratingStyle}`}
    >
      <span className={`${baseTextClass} opacity-70`}>Rating:</span>
      <span className={baseTextClass}>{ratingText}</span>
    </div>
  )
}

export default RatingChip